import { ORDER_PAYMENT_TYPE_LIST } from "../../../../utils/configs";
import { FaFile, FaMoneyBill1, FaRegCreditCard, FaList } from 'react-icons/fa6';

const getOrderPaymentType = (params) => {
  if (params) {
    const paymentType = params.data.paymentTypeRaw;
    if (paymentType) {
      const ptObj = ORDER_PAYMENT_TYPE_LIST.find( _ => _.value === paymentType );
      if (ptObj) {
        return (
          <>
          { ptObj.value === 'none' && <FaFile color={ ptObj.colorCode_text ?? '' } size={16}/> }
          { ptObj.value === 'cash' && <FaMoneyBill1 color={ ptObj.colorCode_text ?? '' } size={16}/> }
          { ptObj.value === 'card' && <FaRegCreditCard color={ ptObj.colorCode_text ?? '' } size={16}/> }
          { ptObj.value === 'multiple' && <FaList color={ ptObj.colorCode_text ?? '' } size={16}/> }
            &nbsp;&nbsp;<span >{ ptObj.label }</span>
          </>
        )
      }
    }
    return paymentType;
  }
}

export const PaymentTypeRenderSel = (props) => {
    let dd = props.data ? getOrderPaymentType(props) : null;
    return (
        <div className="paymentType-renderer">
            {dd}
        </div>
    );
};